webpackJsonp([25],{

/***/ 407:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(34)(
  /* script */
  __webpack_require__(780),
  /* template */
  __webpack_require__(863),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 780:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_handy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__utils_handy__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      lAction: '',
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      beingSaved: false,
      handy: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a,
      rules: __WEBPACK_IMPORTED_MODULE_2__utils_handy___default.a.rules,
      tab: 'tab-0',
      ticketList: {},
      ticket: '',
      tabitems: ['all open', 'all closed'],
      ticketheadsm: [{ text: 'Ticket No', value: 'ticket_no' }, { text: 'Description', value: 'ticket_desc' }, { text: 'Severity', value: 'severity' }, { text: 'Status', value: 'ticket_status' }],
      ticketHead: [{ text: 'Ticket No', value: 'ticket_no' }, { text: 'Description', value: 'ticket_desc' }]
    };
  },
  created: function created() {
    // initialize maps
    for (var i = 0; i < this.tabitems.length; i++) {
      this.ticketList[this.tabitems[i]] = [];
    }
    // load ticket settings
    this.loadTicketList();
  },
  mounted: function mounted() {
    this.lAction = 'view';
  },

  methods: {
    msg: function msg(m) {
      var isError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.sbarCol = isError ? 'error' : 'success';
      this.sbar = true;
      this.sbarMsg = m;
    },
    getEmptyTicket: function getEmptyTicket() {
      var emptyTicket = {
        user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID,
        comp_by: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.CUST_NAME,
        comp_block_unit: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS[0].block_nm + ' ' + __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.UNITS[0].unit_no,
        comp_phone: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.MOBILE_NO,
        comm_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.COMM_ID,
        severity: 'Normal',
        is_critical: false,
        ticket_desc: '',
        ticket_title: '',
        ticket_status: 'New',
        raised_mode: 'APP',
        ticket_on: 'Smartility'
      };
      return emptyTicket;
    },
    prepareCreate: function prepareCreate() {
      this.ticket = this.getEmptyTicket();
      this.lAction = 'create';
    },
    prepareEdit: function prepareEdit(curTicket) {
      this.ticket = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, curTicket); // keep the original object safely before changes
      this.lAction = 'update';
    },
    loadTicketList: function loadTicketList() {
      var _this = this;

      var qry = {
        params: {
          user_id: __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSmartilityTicketByUserId/', qry).then(function (response) {
        _this.ticketList['all open'] = response.data.filter(function (ticket) {
          return ticket.ticket_status === 'New' || ticket.ticket_status === 'Assigned' || ticket.ticket_status === 'Reopened' || ticket.ticket_status === 'In Progress' || ticket.ticket_status === 'On-hold';
        });
        _this.ticketList['all closed'] = response.data.filter(function (ticket) {
          return ticket.ticket_status === 'Resolved' || ticket.ticket_status === 'Rejected';
        });
        if (_this.ticketList['all open'].length) {
          _this.loadTicket(_this.ticketList['all open'][0]);
        }
        if (_this.ticketList['all closed'].length) {
          _this.loadTicket(_this.ticketList['all closed'][0]);
        }
        _this.$forceUpdate();
      }).catch(function (err) {
        _this.msg(err.response.data, true);
      });
    },
    cancelChanges: function cancelChanges() {
      if (this.action) {
        // in case come from different parent page, go there
        this.$router.go(-1);
      } else {
        this.lAction = 'view';
      }
    },
    saveChanges: function saveChanges() {
      this.ticket.severity = this.ticket.is_critical ? 'Critical' : this.ticket.severity === 'Major' ? 'Major' : 'Normal';

      if (this.lAction === 'create') {
        this.createTicket();
      } else if (this.lAction === 'update') {
        this.updateTicket();
      }
    },
    createTicket: function createTicket() {
      var _this2 = this;

      // validate and save Changes
      if (this.$refs.lForm.validate()) {
        this.beingSaved = true;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/ticket/create', this.ticket).then(function (response) {
          // refresh the ticket list
          _this2.loadTicketList();
          _this2.lAction = 'view';
          _this2.beingSaved = false;
        }).catch(function (err) {
          _this2.msg(err.response.data, true);
          _this2.beingSaved = false;
        });
      }
    },
    updateTicket: function updateTicket() {
      var _this3 = this;

      // update into db
      this.beingSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/ticket/update', this.ticket).then(function (response) {
        // update front end
        // refresh the list
        _this3.loadTicketList();
        _this3.lAction = 'view';
        _this3.beingSaved = false;
      }).catch(function (err) {
        _this3.msg(err.response.data, true);
        _this3.beingSaved = false;
      });
    },
    deleteItem: function deleteItem(curTicket) {
      var _this4 = this;

      if (!confirm('Sure, you want to delete the ticket "' + curTicket.ticket_title + '"?')) {
        return;
      }
      // up in db
      this.beingSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/ticket/delete', curTicket).then(function (response) {
        // refresh the list
        _this4.loadTicketList();
        _this4.beingSaved = false;
        _this4.$forceUpdate();
      }).catch(function (err) {
        _this4.msg(err.response.data, true);
        _this4.beingSaved = false;
      });
    },
    reopenTicket: function reopenTicket(curTicket) {
      var _this5 = this;

      if (!confirm('Sure, you want to reopen the ticket "' + curTicket.ticket_title + '"?')) {
        return;
      }
      // up in db
      this.beingSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/ticket/reopen', curTicket).then(function (response) {
        // refresh the list
        _this5.loadTicketList();
        _this5.beingSaved = false;
        _this5.$forceUpdate();
      }).catch(function (err) {
        _this5.msg(err.response.data, true);
        _this5.beingSaved = false;
      });
    },
    loadTicket: function loadTicket(curTicket) {
      var _this6 = this;

      var qry = {
        params: {
          ticket_no: curTicket.ticket_no
        }
      };
      this.axios.get(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/getSmartilityTicketDetail/', qry).then(function (response) {
        curTicket.details = response.data;
        _this6.$forceUpdate();
      }).catch(function (err) {
        _this6.msg(err.response.data, true);
        curTicket.details = [];
      });
    },
    cancelComment: function cancelComment(curTicket) {
      curTicket.ready_for_comment = false;
      this.$forceUpdate();
    },
    postComment: function postComment(curTicket) {
      var _this7 = this;

      if (curTicket.comment.notes.trim().length === 0) {
        this.msg('Comment is empty', true);
      } else {
        // save the changes in db
        this.beingSaved = true;
        this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/ticket/comment', curTicket).then(function (response) {
          // refresh comment list
          curTicket.comment.ticket_no = curTicket.ticket_no;
          curTicket.comment.user_id = __WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.USER_ID;
          curTicket.comment.updated_dt = new Date();
          curTicket.comment.updated_by_temp = 'Me';
          curTicket.comment.ticket_status = 'Commented';
          curTicket.details.push(curTicket.comment);
          curTicket.ready_for_comment = false;
          curTicket.comment = null;
          _this7.beingSaved = false;
          _this7.$forceUpdate();
        }).catch(function (err) {
          _this7.msg(err.response.data, true);
          _this7.beingSaved = false;
        });
      }
    },
    prepareComment: function prepareComment(curTicket) {
      curTicket.ready_for_comment = true;
      curTicket.comment = {
        notes: ''
      };
      this.$forceUpdate();
    },
    deleteNotes: function deleteNotes(curTicket, curDetail, idx) {
      var _this8 = this;

      if (!confirm('Sure, you want to delete the comment?')) {
        return;
      }
      // up in db
      this.beingSaved = true;
      this.axios.post(__WEBPACK_IMPORTED_MODULE_1__config_app_cfg___default.a.API_URL + '/ticket/delete-notes', curDetail).then(function (response) {
        // deleting the comment from particular index
        curTicket.details.splice(idx, 1);
        _this8.beingSaved = false;
        _this8.$forceUpdate();
      }).catch(function (err) {
        _this8.msg(err.response.data, true);
        _this8.beingSaved = false;
      });
    }
  }
});

/***/ }),

/***/ 863:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n          " + _vm._s(tabitem + ' (' + _vm.ticketList[tabitem].length + ')') + "\n        ")])
  }), 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "id": ("tab-" + n)
      }
    }, [_c('v-layout', {
      staticClass: "pa-2"
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.ticketList[tabitem].length === 0) ? _c('v-card-text', {
      staticClass: "info--text text-xs-center"
    }, [_vm._v("No Tickets!")]) : _vm._e(), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.ticketList[tabitem]), function(ticketItem, i) {
      return _c('v-expansion-panel-content', {
        key: i,
        attrs: {
          "value": i === 0
        },
        on: {
          "input": function($event) {
            return _vm.loadTicket(ticketItem)
          }
        }
      }, [_c('div', {
        attrs: {
          "slot": "header"
        },
        slot: "header"
      }, [_c('v-layout', {
        staticClass: "pb-4",
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        staticClass: "caption",
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "pa-1 grey lighten-4 caption black--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "left": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s('Ticket #' + ticketItem.ticket_no) + "\n                        ")]), _vm._v(" "), (ticketItem.ticket_status === 'New' || ticketItem.ticket_status === 'Reopened') ? _c('div', {
        staticClass: "pa-1 red lighten-2",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : (ticketItem.ticket_status === 'Assigned') ? _c('div', {
        staticClass: "pa-1 blue lighten-2",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : (ticketItem.ticket_status === 'In Progress') ? _c('div', {
        staticClass: "pa-1 yellow black--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : (ticketItem.ticket_status === 'Resolved') ? _c('div', {
        staticClass: "pa-1 success",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : _c('div', {
        staticClass: "pa-1 error",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        class: _vm.$vuetify.breakpoint.sm ? 'ml-2' : '',
        attrs: {
          "xs9": "",
          "sm9": "",
          "md11": ""
        }
      }, [_c('div', {
        staticClass: "subheading"
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_title) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "caption grey--text mt-2"
      }, [_c('span', {
        staticClass: "mr-2"
      }, [_vm._v(_vm._s(_vm.handy.formatDateTime(ticketItem.ticket_dt)))])])])], 1)], 1), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": ""
        }
      }, [_c('v-card-text', {
        staticClass: "pt-2 pb-2"
      }, [_c('div', {
        staticClass: "pb-3"
      }, [_vm._v(_vm._s(ticketItem.ticket_desc))]), _vm._v(" "), _vm._l((ticketItem.details), function(det, d) {
        return _c('v-card', {
          key: d,
          staticClass: "grey lighten-4 mb-1"
        }, [_c('v-card-text', {
          staticClass: "pt-2 pr-2 pb-0 pl-2"
        }, [_c('div', [_c('span', {
          staticClass: "caption grey--text"
        }, [_vm._v(_vm._s(det.ticket_status) + " by " + _vm._s(det.updated_by_temp) + " " + _vm._s(det.ticket_status === 'Assigned' && det.assigned_to ? ' to ' + det.assigned_to : '') + " - " + _vm._s(_vm.handy.formatDateTime(det.updated_dt)))]), _vm._v(" "), _c('div', {
          staticClass: "info--text"
        }, [_vm._v(_vm._s(det.notes) + " ")])])]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "pt-0"
        }, [_c('v-spacer'), _vm._v(" "), (det.user_id && tabitem !== 'all closed') ? _c('v-btn', {
          staticClass: "mt-0",
          attrs: {
            "icon": "",
            "disabled": _vm.beingSaved
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteNotes(ticketItem, det, d)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)
      }), _vm._v(" "), (ticketItem.ready_for_comment) ? _c('div', [_c('div', [_c('span', {
        staticStyle: {
          "float": "right"
        },
        attrs: {
          "color": "grey"
        }
      }, [_c('v-btn', {
        staticClass: "ma-0",
        attrs: {
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.cancelComment(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "hide-details": "",
          "textarea": "",
          "placeholder": "Your comment",
          "rows": "2"
        },
        model: {
          value: (ticketItem.comment.notes),
          callback: function($$v) {
            _vm.$set(ticketItem.comment, "notes", $$v)
          },
          expression: "ticketItem.comment.notes"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right"
        }
      }, [_c('v-btn', {
        staticClass: "ma-0",
        attrs: {
          "flat": "",
          "color": "accent",
          "disabled": _vm.beingSaved
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.postComment(ticketItem)
          }
        }
      }, [_vm._v("Comment")])], 1)]) : _vm._e(), _vm._v(" "), (!ticketItem.ready_for_comment) ? _c('div', [_c('v-card', [_c('v-card-actions', {
        staticClass: "ma-0 pa-0"
      }, [_c('v-spacer'), _vm._v(" "), (tabitem === 'all open') ? _c('v-btn', {
        staticClass: "pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareComment(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("comment")])], 1) : _vm._e(), _vm._v(" "), (tabitem === 'all open') ? _c('v-btn', {
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareEdit(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (tabitem === 'all open') ? _c('v-btn', {
        attrs: {
          "icon": "",
          "disabled": _vm.beingSaved
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteItem(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (tabitem === 'all closed') ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": "",
          "disabled": _vm.beingSaved
        },
        nativeOn: {
          "click": function($event) {
            return _vm.reopenTicket(ticketItem)
          }
        }
      }, [_vm._v("Reopen")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 2)], 1)], 1)
    }), 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:65px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 2) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " Ticket\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "title",
    attrs: {
      "label": "Ticket title",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.ticket.ticket_title),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "ticket_title", $$v)
      },
      expression: "ticket.ticket_title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "label": "Ticket description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "multi-line": "",
      "rows": "4",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.ticket.ticket_desc),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "ticket_desc", $$v)
      },
      expression: "ticket.ticket_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-1 subheading",
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('span', [_vm._v("Is it critical?")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.ticket.is_critical ? 'Yes' : 'No',
      "hide-details": ""
    },
    model: {
      value: (_vm.ticket.is_critical),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "is_critical", $$v)
      },
      expression: "ticket.is_critical"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Log")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/25.f648e052fad40ee3d3bf.js